import React from "react";
import { useIsDesktop } from "../../../hooks/useIsDesktop";

const categories = [
  {
    title: "ค่าใช้จ่าย",
    rows: [
      {
        label: "Subby Subscription",
        desc: "เริ่มง่ายกว่าไม่ต้องเสียค่าใช้จ่ายก้อนใหญ่ล่วงหน้า ก็สามารถเป็นเจ้าของเครื่องใช้ไฟฟ้า ได้ด้วยการจ่ายค่าบริการรายเดือน",
      },
      {
        label: "การซื้อขาด",
        desc: "ต้องใช้เงินก้อนใหญ่ในการซื้อ ซึ่งอาจเป็นภาระทางการเงินได้",
      },
    ],
  },
  {
    title: "การรับประกัน",
    rows: [
      {
        label: "Subby Subscription",
        desc: "มีการรับประกัน 5 - 7 ปี (ตลอดอายุสัญญา)",
      },
      {
        label: "การซื้อขาด",
        desc: "มีการรับประกัน 1 - 2 ปี",
      },
    ],
  },
  {
    title: "การบำรุงรักษา",
    rows: [
      {
        label: "Subby Subscription",
        desc: "ครอบคลุมการบำรุงรักษาและการเปลี่ยนผลิตภัณฑ์เนื่องจากเสื่อมสภาพของสินค้า",
      },
      {
        label: "การซื้อขาด",
        desc: "ผู้ซื้อต้องแบกรับผลิตภัณฑ์ทั้งริ่มต้องรับผิดชอบค่าใช้จ่ายทั้งหมดสำหรับการบำรุงรักษาและซ่อมแซม",
      },
    ],
  },
];

const footerLinks = [
  { text: "สินค้าทั้งหมด" },
  { text: "การช่วยเหลือและสนับสนุน" },
  { text: "ติดต่อฝ่ายบริการ" },
  { text: "เกี่ยวกับเรา" },
];

const ComparisonSection = () => {
  const isDesktop = useIsDesktop();

  return (
    <section
      style={{
        backgroundColor: "#fff",
        padding: isDesktop ? "60px 40px" : "40px 20px",
      }}
    >
      <div style={{ maxWidth: "720px", margin: "0 auto" }}>
        {/* Title */}
        <h2
          style={{
            fontSize: isDesktop ? "24px" : "20px",
            fontWeight: 700,
            color: "var(--color-text-primary, #322E2D)",
            marginBottom: "32px",
          }}
        >
          การซื้อขาด VS Subscription
        </h2>

        {/* Categories */}
        {categories.map((cat, catIdx) => (
          <div key={catIdx} style={{ marginBottom: "24px" }}>
            {/* Category Header */}
            <div
              style={{
                backgroundColor: "var(--color-primary, #FF6500)",
                color: "#fff",
                padding: "12px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: 600,
                textAlign: "center",
                marginBottom: "16px",
              }}
            >
              {cat.title}
            </div>

            {/* Rows */}
            {cat.rows.map((row, rowIdx) => (
              <div
                key={rowIdx}
                style={{
                  display: "flex",
                  gap: "16px",
                  padding: "12px 0",
                  borderBottom: rowIdx < cat.rows.length - 1 ? "1px solid var(--color-border, #E6E4E4)" : "none",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    minWidth: isDesktop ? "160px" : "110px",
                    fontSize: isDesktop ? "14px" : "12px",
                    fontWeight: 700,
                    color: "var(--color-text-primary, #322E2D)",
                    flexShrink: 0,
                  }}
                >
                  {row.label}
                </div>
                <div
                  style={{
                    fontSize: isDesktop ? "13px" : "11px",
                    color: "var(--color-text-secondary, #78706E)",
                    lineHeight: 1.6,
                  }}
                >
                  {row.desc}
                </div>
              </div>
            ))}
          </div>
        ))}

        {/* Notice */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 0",
            borderTop: "1px solid var(--color-border, #E6E4E4)",
            marginTop: "8px",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              color: "var(--color-primary, #FF6500)",
            }}
          >
            * รายละเอียด โปรโมชั่นและราคาจ่ายอาจแตกต่างกันไปในแต่ละร้านค้าและออนไลน์...
          </span>
          <span
            style={{
              fontSize: "12px",
              color: "var(--color-primary, #FF6500)",
              fontWeight: 600,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            เพิ่มเติม
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 0",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              color: "var(--color-primary, #FF6500)",
            }}
          >
            * โทรศัพท์ ทุกวัน 8:00 - 18:00 น. 02-xxx-xxxx ...
          </span>
          <span
            style={{
              fontSize: "12px",
              color: "var(--color-primary, #FF6500)",
              fontWeight: 600,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            เพิ่มเติม
          </span>
        </div>

        {/* Footer Links */}
        <div style={{ marginTop: "24px" }}>
          {footerLinks.map((link, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 0",
                borderBottom: "1px solid var(--color-border, #E6E4E4)",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "var(--color-text-primary, #322E2D)",
                }}
              >
                {link.text}
              </span>
              <span
                style={{
                  fontSize: "18px",
                  color: "var(--color-text-secondary, #78706E)",
                  transform: "rotate(0deg)",
                  transition: "transform 0.2s",
                }}
              >
                ∨
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
